export function permission(){
	let list=[
		{value:"free_personal",label:"免费个人版"},
		{value:"pro_personal",label:"个人专业订阅版（进阶 / 高阶）"},
		{value:"enterprise",label:"企业版空间"}
	]
	return list
}

